export const getDisplayName = (fullName, firstName, lastName, nickName) => {
  let name = fullName
  if (!name) {
    name = `${firstName || ''} ${lastName || ''}`.trim()
  }
  if (nickName) {
    name = `${name} (${nickName || ''})`
  }

  return `${name}`.trim()
}
